"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactVirtualizedSelect = _interopRequireDefault(require("react-virtualized-select"));

var _reactIntl = require("react-intl");

var _reactComponents = require("@cimpress/react-components");

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

var ListPriceInitiatorMerchantSelectStep =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ListPriceInitiatorMerchantSelectStep, _React$PureComponent);

  function ListPriceInitiatorMerchantSelectStep() {
    (0, _classCallCheck2.default)(this, ListPriceInitiatorMerchantSelectStep);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListPriceInitiatorMerchantSelectStep).apply(this, arguments));
  }

  (0, _createClass2.default)(ListPriceInitiatorMerchantSelectStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          merchantId = _this$props.merchantId,
          onMerchantIdChange = _this$props.onMerchantIdChange,
          allowedMerchants = _this$props.allowedMerchants,
          formatMessage = _this$props.intl.formatMessage;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h5", null, formatMessage(_listPriceInitiatorMessages.selectMerchantStep.header)), _react.default.createElement(_reactComponents.SelectWrapper, {
        selectedSelect: _reactVirtualizedSelect.default,
        label: formatMessage(_listPriceInitiatorMessages.selectMerchantStep.merchantSelectLabel),
        value: merchantId || undefined,
        options: allowedMerchants,
        onChange: onMerchantIdChange
      }), _react.default.createElement("div", {
        style: {
          height: '170px'
        }
      }));
    }
  }]);
  return ListPriceInitiatorMerchantSelectStep;
}(_react.default.PureComponent);

var _default = (0, _reactIntl.injectIntl)(ListPriceInitiatorMerchantSelectStep);

exports.default = _default;